import type { Theme } from '../types';
import { Bubbles } from './Bubbles';

// Ocean — teal-to-deep-blue gradient with rising bubbles.
export const oceanTheme: Theme = {
  key: 'ocean',
  name: 'Meri',
  tokens: {
    bodyBackground: 'linear-gradient(180deg, #0e7490 0%, #0891b2 50%, #67e8f9 100%)',
    pageHeadingColor: '#ffffff',
    pageHeadingShadow: '0 4px 0 rgba(8, 47, 73, 0.45)',
    routineCardSurface: 'rgba(255, 255, 255, 0.55)',
    cardSurface: 'rgba(255, 255, 255, 0.85)',
    accent: '#0891b2',
  },
  decoration: { kind: 'component', component: Bubbles },
  routineCardPalette: ['#fb7185', '#fdba74', '#facc15', '#86efac', '#5eead4', '#7dd3fc'],
};
